import React from 'react'
import { Link } from 'react-router-dom'

export default function Error404() {

    return (
        <>
            <div className="container-fluid py-5">
                <div className="container py-5 text-center">
                    <div className="row justify-content-center">
                        <div className="col-lg-6">
                            <i className="bi bi-exclamation-triangle display-1 text-dark"></i>
                            <h1 className="display-1">404</h1>
                            <h1 className="mb-4">Page Not Found</h1>
                            {/* <p className="mb-4">We’re sorry, the page you have looked for does not exist in our website! Maybe go to our home page or try to use a search?</p> */}
                            <p className="mb-4">We’re sorry, your are not authorized user to perform this operation,first you have to login</p>
                            <Link className="btn border-dark rounded-pill py-2 px-4" to="/login">Go Back To Login</Link>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}
